import { render, staticRenderFns } from "./InputModifyMetadataDialog.vue?vue&type=template&id=8ac26734&"
import script from "./InputModifyMetadataDialog.vue?vue&type=script&lang=js&"
export * from "./InputModifyMetadataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports